// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__qi19G","head":"ProcedureTableInfo_head__1xUFO"};